import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
    infoIcon: {
        fontSize: 16,
    },
    activeFilterIcon: {
        color: theme.palette.warning.main,
    },
    card: { marginBottom: theme.spacing(5) },
    cardTitleBox: { display: "flex", gap: theme.spacing(2), alignItems: "center" },
    cardContent: { display: "flex", flexDirection: "column", gap: theme.spacing(2), "&.MuiCardContent-root": { paddingTop: 0 } },
    filterActions: { display: "flex", gap: theme.spacing(2), justifyContent: "flex-end", alignItems: "center" },
    toolbar: { display: "flex", alignItems: "center", gap: theme.spacing(2), marginBottom: theme.spacing(2) },
    searchContainer: { flex: 1, minWidth: 240 },
    dataPayload: { margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word", overflowWrap: "anywhere" },
}));
